"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioButtonContainer = void 0;
var Utils_1 = require("../../../utils/Utils");
var GameVars_1 = require("../../../GameVars");
var AudioManager_1 = require("../../../AudioManager");
var AudioButtonContainer = /** @class */ (function (_super) {
    __extends(AudioButtonContainer, _super);
    function AudioButtonContainer(scene) {
        var _this = _super.call(this, scene) || this;
        _this.audioOnButton = new Utils_1.Button(_this.scene, 0, 0, "texture_atlas_1", "btn_sound_on_off", "btn_sound_on_on");
        _this.audioOnButton.onDown(_this.onClickAudioButton, _this);
        _this.audioOnButton.setScrollFactor(0);
        _this.add(_this.audioOnButton);
        _this.audioOffButton = new Utils_1.Button(_this.scene, 0, 0, "texture_atlas_1", "btn_sound_off_off", "btn_sound_off_on");
        _this.audioOffButton.onDown(_this.onClickAudioButton, _this);
        _this.audioOffButton.setScrollFactor(0);
        _this.add(_this.audioOffButton);
        if (GameVars_1.GameVars.gameData.muted) {
            _this.audioOnButton.visible = false;
            _this.audioOffButton.visible = true;
        }
        else {
            _this.audioOnButton.visible = true;
            _this.audioOffButton.visible = false;
        }
        return _this;
    }
    AudioButtonContainer.prototype.onClickAudioButton = function () {
        AudioManager_1.AudioManager.toggleAudioState();
        if (GameVars_1.GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        }
        else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    };
    return AudioButtonContainer;
}(Phaser.GameObjects.Container));
exports.AudioButtonContainer = AudioButtonContainer;
